import React, { useRef, useState } from "react";
import { useField } from "formik";
import Button from "../../../components/button/button";

interface myProps {
  label: string;
  type: string;
  placeholder: string;
  name: string;
  id: string;
  fileType: string;
  classsName?: string;
  required?: boolean;
  onChange: (e: any, documentType: string) => {};
}
const MyTextField: React.FC<myProps> = ({
  label,
  classsName,
  onChange,
  fileType,
  required,
  ...props
}) => {
  const [field, meta] = useField(props);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState<string>("");

  // Avoid passing value to file input (read-only in DOM)
  const { value: _omitValue, ...fieldProps } = field as any;
  const { id: idProp, ...restInputProps } = props as any;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFileName(e.target.files?.[0]?.name || "");
    onChange(e, fileType);
    field.onChange(e);
  };

  const triggerFileDialog = () => {
    inputRef.current?.click();
  };
  return (
    <>
      <label
        className="font-medium text-base mt-3"
        htmlFor={props.id || props.name}
      >
        {label} {required && <span className="text-red-500 text-lg">*</span>}
      </label>
      {/* Hidden native input */}
      <input
        ref={inputRef}
        id={idProp || fieldProps.name}
        className="sr-only"
        {...fieldProps}
        {...restInputProps}
        onChange={handleInputChange}
        type="file"
      />

      {/* Custom file chooser */}
      <div
        className={`mt-2 flex justify-between items-center gap-3  border rounded-lg border-[#E2E5EA] py-2 px-2 focus:border-[#E2E5EA] border-solid ${
          classsName ?? ""
        }`}
      >
        <span
          className={`text-sm text-gray-600 transition-opacity duration-300 ${
            fileName ? "opacity-100" : "opacity-70"
          }`}
        >
          {fileName || "No file chosen"}
        </span>
        <Button
          type="button"
          variant="secondary"
          size="small"
          onClick={triggerFileDialog}
          ariaLabel={`Choose ${label}`}
          className="max-h-7 max-w-[69px] font-normal"
        >
          choose
        </Button>
      </div>
      {meta.error ? (
        <div className="error text-red-400">{meta.error}</div>
      ) : null}
    </>
  );
};

export default MyTextField;
